export default "__VITE_ASSET__33a0bf45__"